import { quizTranslationState, quizTranslationType } from "components"
import { useEffect, useState } from "react"
import { useRecoilValue } from "recoil"
import { QuizTooltip } from "../components/QuizTootip"

export const useTooltip = (txt?: string): TooltipType => {
    const [content, setContent] = useState<TooltipType>()
    const translations = useRecoilValue(quizTranslationState)
    const [dictionary, setDictionary] = useState<[quizTranslationType] | []>([])

    useEffect(() => {
        if(translations) {
            setDictionary(translations.filter((item: Record<string, string>) => 
            item.key.toLowerCase().indexOf('dictionary') != -1) as [quizTranslationType])
        }
    }, [translations])
    
    useEffect(() => {
        if(txt && dictionary?.length > 0) {
            const def = searchDefinition(txt)
            if(def?.key) {
                const res = txt.replace(def.value.toLowerCase(), '$definition').split(' ').map((item: string, index: number) => {
                        if(item.indexOf('$definition') != -1 ) {
                            return <QuizTooltip key={`tooltip-${index}`} text={def.key.split('.')?.[2]} />
                        } 
                        return `${item} `
                    })
                setContent(res)
            } else {
                setContent([txt])
            }
        }
    }, [txt, dictionary])

    const searchDefinition = (txt: string) => 
        dictionary.find((item: quizTranslationType) => txt.toLowerCase().indexOf(item.value.toLowerCase())  != -1)
    

    return content
}

export type TooltipType = (string | JSX.Element)[] | undefined